import type { RenderExpandIconProps } from 'rc-table/lib/interface'

import { CaretDownOutlined, CaretRightOutlined } from '@ant-design/icons'
import cx from 'classnames'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ExpandIcon = (props: RenderExpandIconProps<any>): JSX.Element | null => {
  if (!props.expandable) {
    return null
  }

  return (
    <button
      className={cx('-ml-1 p-2 flex items-center justify-center transition-opacity translate-x-2', {
        'opacity-50 hover:opacity-75': !props.expanded,
        'opacity-100': props.expanded
      })}
      onClick={e => {
        props.onExpand(props.record, e)
      }}
    >
      {props.expanded && <CaretDownOutlined />}

      {!props.expanded && <CaretRightOutlined />}
    </button>
  )
}
